var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5092 4.05486C18.7039 7.02081 18.9804 11.9824 16.135 15.285L21.925 21.075L21.075 21.925L15.285 16.135C11.9824 18.9804 7.02081 18.7039 4.05486 15.5092C1.0889 12.3145 1.1811 7.34601 4.26356 4.26356C7.34601 1.1811 12.3145 1.0889 15.5092 4.05486ZM9.99998 3.09998C6.18921 3.09998 3.09998 6.18921 3.09998 9.99998C3.10273 13.8096 6.19035 16.8972 9.99998 16.9C13.8107 16.9 16.9 13.8107 16.9 9.99998C16.9 6.18921 13.8107 3.09998 9.99998 3.09998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9f82e20c991cec199c6b2adfcd2d84e4.svg";
export { ForwardRef as ReactComponent };